/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import { CTAButton } from 'components/atoms/Button/Button';
import '../downloadRcm.scss';
import { goToCustomUrl } from 'controls/utils';

export function OSList({ data }) {
  const osList = Object.values(data);

  return (
    <div>
      <div className='osListContainer'>
        {osList.map((os) => (
          <div key={os.title} className='os'>
            <img
              src={os.imageUrl}
              alt='Roland Cloud Manager'
            />
            <div
              className='os_title'
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(os.title) }}
            />
            <div
              className='os_body'
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(os.body) }}
            />
            <CTAButton
              ctaText={os.ctaText}
              showIcon={false}
              onClick={() => goToCustomUrl(os.ctaUrl)}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

OSList.propTypes = {
  data: PropTypes.objectOf(
    PropTypes.shape({
      imageUrl: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      body: PropTypes.string.isRequired,
      ctaText: PropTypes.string.isRequired,
      ctaUrl: PropTypes.string.isRequired,
    }),
  ).isRequired,
};
